/* eslint-disable no-constant-binary-expression */
import { FC } from 'react';
import arrowRightIcon from 'assets/icons/arrow-right-icon.svg';
import groupMembersBlackIcon from 'assets/icons/group-members-black-icon.svg';
import { clsx } from 'clsx';
import { addTime } from 'shared/lib';

import { ICardLineTeacherScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const СardLineTeacherSchedule: FC<ICardLineTeacherScheduleProps> = ({
  data,
}) => {
  return (
    <div className={styles['card-line-schedule']}>
      <div>
        <div className={styles['card-line-schedule__disctime']}>
          {data.disciplTime} <div>—</div> <div>{addTime(data.disciplTime)}</div>
        </div>
      </div>

      <div className={styles['card-line-schedule__info']}>
        <div style={{ display: 'flex' }}>
          <div
            className={clsx(styles['card-line-schedule__disctype'], {
              [styles['card-line-schedule__disctype_red']]:
                data.disciplType === 'Лекция',
              [styles['card-line-schedule__disctype_blue']]:
                data.disciplType === 'Лабораторная работа',
              [styles['card-line-schedule__disctype_purple']]:
                data.disciplType === 'Практика',
            })}
          >
            <div>{data.disciplType}</div>
          </div>

          <img
            style={{ margin: '0px 6px 0px 6px' }}
            src={arrowRightIcon}
            alt="указатель"
          />

          <div className={styles['card-line-schedule__tags']}>
            {data.groupsTags.map((tag) => {
              return (
                <div className={styles['card-line-schedule__tag']} key={tag}>
                  <img
                    style={{ marginRight: '2px' }}
                    src={groupMembersBlackIcon}
                    alt="groupMember"
                  />
                  {tag}
                </div>
              );
            })}
          </div>
          {data.subgroupNum && (
            <div className={styles['card-line-schedule__subgroup']}>
              {data.subgroupNum}
              <div className={styles['card-line-schedule__subgroup-text']}>
                подгруппа
              </div>
            </div>
          )}
        </div>

        <div className={styles['card-line-schedule__discname']}>
          {data.disciplName}
        </div>
        <div className={styles['card-line-schedule__building-auditory']}>
          {data.location}
        </div>
      </div>
    </div>
  );
};
